import TagManager from 'react-gtm-module';
import { getOsName } from './userAgentUtil';

const osName = getOsName();

/**
 * GTM 에 데이터를 put 해주는 함수
 * 현재는 amplitude만 존재하지만
 * 새로운 형태가 추가된다면  필요에 따라 'brazerData' 같은 형태로 추가 되면된다
 * ex)  (eventName: string, amplitudeData?: any ,brazerData?: any)
 * @param eventName
 * @param dataTypes
 */
export const putTagManager = (
  isNativeAppBoth: boolean,
  eventName: string,
  amplitudeData?: any
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      amplitudeData,
      isNativeApp: isNativeAppBoth,
      osName,
    },
  });
};

export const putTagManagerWithDataLayer = (
  isNativeAppBoth: boolean,
  dataLayer: any
) => {
  const temp = { ...dataLayer };
  temp.isNativeApp = isNativeAppBoth;
  temp.osName = osName;

  TagManager.dataLayer({
    dataLayer,
  });
};

export const putTagManagerWithAppDataLayer = (
  isNativeAppBoth: boolean,
  triggerName: string,
  appEventType: string,
  tagData: any
) => {
  const appAmplitudeData = {
    event_name: appEventType,
    event_value: {
      name: tagData?.event,
      attr: tagData?.amplitudeData || {},
    },
  };

  TagManager.dataLayer({
    dataLayer: {
      event: triggerName,
      amplitudeData: appAmplitudeData,
      isNativeApp: isNativeAppBoth,
      osName,
    },
  });
};
